import { SxProps, Theme } from '@mui/material';
import { t } from 'i18next';

export type VendorTicketsTableColumn = {
  key: string;
  size: string;
  sx?: SxProps<Theme>;
  title?: string;
};

export const columns: VendorTicketsTableColumn[] = [
  {
    key: 'vendor',
    title: t('common.vendor'),
    size: '3fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'tickets',
    title: t('dispatch.job.tickets'),
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'total_quantity',
    title: t('dispatch.tickets_table.vendor_tickets_summary.total_quantity'),
    size: '1.5fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'trucks',
    title: t('form_fields.trucks'),
    size: '1.2fr',
    sx: { p: 1, overflow: 'hidden' },
  },
];

export const gridTemplateColumns = columns.map((column) => column.size).join(' ');
